import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useModalStore = defineStore('ap.modal', () => {
  const component = ref<Component | null>(null);
  const props = ref<Record<string, any>>({});
  const isOpen = ref(false);

  function open(comp: Component, modalProps: Record<string, any> = {}) {
    component.value = markRaw(comp);
    props.value = modalProps;
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
    component.value = null;
    props.value = {};
  }

  return {
    component,
    props,
    isOpen,
    open,
    close,
  };
});
